<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title style="padding-left: 10px">
          {{ $t(formName)}}
        </v-toolbar-title>
      </v-toolbar>
      <v-form @keyup.enter.native="onSave" id="createForm" lazy-validation ref="createForm" v-model="formValid">
        <v-layout wrap>
          <v-flex style="padding: 10px" xs12>
            <v-textarea
                :data-vv-as="$t('lang.emailConfig.signature')" :error-messages="errors.first('signature')"
                :label="$t('lang.emailConfig.signature')"
                name="signature"
                v-model="item['signature']"
                outlined
                rows="10"
            ></v-textarea>
          </v-flex>

        </v-layout>
      </v-form>
      <div style="text-align: right">
        <v-btn @click="onSave" color="primary">
          <v-icon dark left>save</v-icon>
          {{$t('lang.common.save')}}
        </v-btn>
      </div>
    </v-card>
  </div>


</template>

<script>
  import axios from "axios";
  import {message} from "@/shared/message";

  export default {
    name: 'email-signature-edit',
    components: {},
    inheritAttrs: true,
    props: {
      propsItem: {
        type: Object,
        default: null,
      },
    },
    data: () => {
      return {
        formName: "Cập nhật Chữ ký",
        formValid: false,
        item: {
          signature: '',
        },
        model: {},
      }
    },
    methods: {
      resetFrom: function () {
        this.item = {
          signature: ""
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
      },
      onSave: function () {
        this.$validator.validate().then(
          valid => {
            if (!valid) {
              message.error(this.$t('lang.common.validate_fail'));
              return;
            }
            axios.post(process.env.VUE_APP_API_URL + "/emailSignature/save", this.item).then(data => {
              if (data.success) {
                message.success(this.$t("lang.common.save_success"));
                this.$emit("save", this.item);
                this.onCancel();
              } else {
                message.error(this.$t(data.description));
              }
            }, error => {
              message.error(error);
            });

          }
        )
      },
    },
    created() {
      axios.post(process.env.VUE_APP_API_URL + "/emailSignature/search?page=-1&pageSize=-1", {}).then(
          data => {
            this.item = data;
          }
      )
      //this.loadSignature()
    },


  }
</script>
